<div class="page-layout simple fullwidth">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <h2>{{ "PURCHASE.PURCHASE" | translate | uppercase }}</h2>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="center p-24 pb-56">
        <div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="start center">
                <div class="h1 pr-16">Ordenes de Compra</div>
                <button
                    mat-icon-button
                    color="accent"
                    (click)="mostrarFiltros = !mostrarFiltros"
                >
                    <mat-icon color="secondary">filter_list</mat-icon>
                </button>
            </div>

            <!-- div fxLayout="row" fxLayoutAlign="start center">
                <div class="h1 pr-16">Ordenes de Compra</div -->
            <!-- button
                    mat-icon-button
                    color="accent"
                    (click)="mostrarFiltros = !mostrarFiltros"
                >
                    {{ mostrarFiltros ? "Ocultar filtros" : "Mostrar filtros" }}
                    <mat-icon>{{
                        mostrarFiltros
                            ? "keyboard_arrow_up"
                            : "keyboard_arrow_down"
                    }}</mat-icon>
                </button>
                    <mat-icon color="secondary">filter_list</mat-icon>
                </button -->
            <!-- /div -->
            <!-- div fx-flex fx-layout-align="end">
                <button
                mat-icon-button
                color="accent"
                (click)="mostrarFiltros = !mostrarFiltros"
            >
                {{
                    mostrarFiltros
                        ? "Ocultar filtros"
                        : "Mostrar filtros"
                }}
                <mat-icon>{{
                    mostrarFiltros
                        ? "keyboard_arrow_up"
                        : "keyboard_arrow_down"
                }}</mat-icon>
            </button>
            </div -->

            <app-searchbox
                *ngIf="clientes && estados"
                class="mb-16"
                [hidden]="!mostrarFiltros"
                [estados]="estados"
                [clientes]="clientes"
                [setearFiltros]="setearFiltros"
                [recepciones]="recepciones"
                (filtrarOrdenesCompra)="filtrar($event)"
            >
            </app-searchbox>

            <app-tabla-oocc
                *ngIf="oocc"
                [total]="total"
                [oocc]="oocc"
                (asociarFacturaEvent)="asociarFactura($event)"
                (verOOTTEvent)="verOOTT($event)"
                (buscarMas)="buscarOrdenesCompra($event)"
            >
            </app-tabla-oocc>
        </div>
    </div>

    <!-- / CONTENT -->
</div>
